import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const LaporanGuruRekapPage = () => {
  const navigate = useNavigate();
  
  // Dummy data for laporan guru
  const laporanGuruData = [
    {
      id: 1,
      tanggal: '25 April 2025',
      sikap: 'Sikap',
      pelapor: 'Kris',
      keterangan: 'Rokok',
      poin: '-70'
    },
    {
      id: 2,
      tanggal: '20 April 2025',
      sikap: 'Sikap',
      pelapor: 'Budi',
      keterangan: 'Rusak bubut',
      poin: '-50'
    },
    {
      id: 3,
      tanggal: '15 April 2025',
      sikap: 'Sikap',
      pelapor: 'Hadi',
      keterangan: 'Tidak pakai seragam',
      poin: '-10'
    },
    {
      id: 4,
      tanggal: '10 April 2025',
      sikap: 'Sikap',
      pelapor: 'Kris',
      keterangan: 'Tidur di kelas',
      poin: '-5'
    },
    {
      id: 5,
      tanggal: '5 April 2025',
      sikap: 'Sikap',
      pelapor: 'Rini',
      keterangan: 'Terlambat masuk kelas',
      poin: '-5'
    },
    {
      id: 6,
      tanggal: '1 April 2025',
      sikap: 'Sikap',
      pelapor: 'Budi',
      keterangan: 'Membuang sampah sembarangan',
      poin: '-10'
    },
    {
      id: 7,
      tanggal: '25 Maret 2025',
      sikap: 'Sikap',
      pelapor: 'Kris',
      keterangan: 'Terlambat masuk sekolah',
      poin: '-10'
    },
    {
      id: 8,
      tanggal: '20 Maret 2025',
      sikap: 'Sikap',
      pelapor: 'Hadi',
      keterangan: 'Mencontek saat ujian',
      poin: '-30'
    },
    {
      id: 9,
      tanggal: '15 Maret 2025',
      sikap: 'Sikap',
      pelapor: 'Rini',
      keterangan: 'Merusak properti sekolah',
      poin: '-20'
    },
    {
      id: 10,
      tanggal: '10 Maret 2025',
      sikap: 'Sikap',
      pelapor: 'Budi',
      keterangan: 'Berkelahi dengan teman',
      poin: '-40'
    }
  ];
  
  return (
    <PageContainer>
      <PageHeader>
        <BackButton onClick={() => navigate('/rekap')}>
          <span>←</span> Kembali
        </BackButton>
        <h1>Rekap Laporan dari Guru</h1>
        <p>Catatan pelanggaran dan perilaku</p>
      </PageHeader>
      
      <TableContainer>
        <DataTable>
          <thead>
            <tr>
              <th>No</th>
              <th>Tanggal</th>
              <th>Sikap</th>
              <th>Pelapor</th>
              <th>Keterangan</th>
              <th>Poin</th>
            </tr>
          </thead>
          <tbody>
            {laporanGuruData.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.tanggal}</td>
                <td>{item.sikap}</td>
                <td>{item.pelapor}</td>
                <td>{item.keterangan}</td>
                <td>
                  <PoinValue negative={parseFloat(item.poin) < 0}>
                    {item.poin}
                  </PoinValue>
                </td>
              </tr>
            ))}
          </tbody>
        </DataTable>
      </TableContainer>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  padding: 1.5rem;
  max-width: 1280px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const PageHeader = styled.div`
  margin-bottom: 2rem;
  position: relative;
  
  h1 {
    font-size: 1.75rem;
    font-weight: 600;
    color: var(--text-dark);
    margin-bottom: 0.5rem;
    text-align: center;
  }
  
  p {
    color: var(--text-light);
    text-align: center;
    font-size: 0.95rem;
  }
`;

const BackButton = styled.button`
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  color: var(--primary);
  font-weight: 500;
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  margin-bottom: 1rem;
  border-radius: 4px;
  transition: all 0.2s ease;
  
  span {
    margin-right: 0.5rem;
    font-size: 1.2rem;
  }
  
  &:hover {
    background-color: var(--primary);
    color: white;
  }
`;

const TableContainer = styled.div`
  background-color: var(--background);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

const DataTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  
  th, td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid var(--border);
  }
  
  th {
    background-color: var(--background-light);
    font-weight: 600;
    color: var(--text-dark);
  }
  
  tr:last-child td {
    border-bottom: none;
  }
  
  tr:hover td {
    background-color: rgba(0, 0, 0, 0.01);
  }
  
  @media (max-width: 768px) {
    display: block;
    overflow-x: auto;
    
    th, td {
      padding: 0.75rem;
    }
  }
`;

const PoinValue = styled.span`
  font-weight: 600;
  color: ${props => props.negative ? '#dc3545' : '#00a389'};
`;

export default LaporanGuruRekapPage;